import { defineMessages } from 'react-intl';

const chooseSignInMethodMessages = defineMessages({
  welcomeBack: {
    id: 'chooseSignInMethod.welcomeBack',
    defaultMessage: 'Welcome back',
    description: 'Welcome back heading on the choose sign in method page.',
  },
  header: {
    id: 'chooseSignInMethod.header',
    defaultMessage: 'Choose a sign in method',
    description: 'Heading for the choose sign in method card.',
  },
  signingInWith: {
    id: 'chooseSignInMethod.signingInWith',
    defaultMessage: 'Signing in with {email}',
    description:
      'Text showing which email the user is signing in with. {email} is the email address.',
  },
  lastUsedEmail: {
    id: 'chooseSignInMethod.lastUsedEmail',
    defaultMessage: 'You last used {email} to sign in.',
    description:
      'Confirmation shown to a returning user who has one sign-in method. {email} is the email address they last signed in with.',
  },
  continueSameAccount: {
    id: 'chooseSignInMethod.continueSameAccount',
    defaultMessage: 'Click Continue to sign in with the same account.',
    description:
      'Instruction under the "You last used {email} to sign in." confirmation, telling the user what the Continue button does.',
  },
  changeEmail: {
    id: 'chooseSignInMethod.changeEmail',
    defaultMessage: 'Change email',
    description: 'Link to change the email address.',
  },
  continueButton: {
    id: 'chooseSignInMethod.continueButton',
    defaultMessage: 'Continue',
    description: 'Continue button label.',
  },
  useDifferentEmail: {
    id: 'chooseSignInMethod.useDifferentEmail',
    defaultMessage: 'Use a different email',
    description: 'Link at the bottom to use a different email.',
  },
  awsBuilderIdDescription: {
    id: 'chooseSignInMethod.awsBuilderIdDescription',
    defaultMessage: 'Sign in with your AWS Builder ID account.',
    description: 'Description for AWS Builder ID sign-in option.',
  },
  loginWithAmazonDescription: {
    id: 'chooseSignInMethod.loginWithAmazonDescription',
    defaultMessage: 'Sign in with your Amazon account.',
    description: 'Description for Login with Amazon sign-in option.',
  },
  amazonFederateDescription: {
    id: 'chooseSignInMethod.amazonFederateDescription',
    defaultMessage: 'Sign in with your Amazon corporate credentials.',
    description: 'Description for Amazon Federate sign-in option.',
  },
  otpDescription: {
    id: 'chooseSignInMethod.otpDescription',
    defaultMessage: 'Sign in with a one-time passcode sent to your email.',
    description: 'Description for OTP sign-in option.',
  },
  organizationalSsoLabel: {
    id: 'chooseSignInMethod.organizationalSsoLabel',
    defaultMessage: 'Organizational SSO',
    description: 'Display name for unknown organization SSO providers.',
  },
  organizationalSsoDescription: {
    id: 'chooseSignInMethod.organizationalSsoDescription',
    defaultMessage: 'Sign in with your organization account.',
    description: 'Description for unknown organization SSO providers.',
  },
  defaultIdpDescription: {
    id: 'chooseSignInMethod.defaultIdpDescription',
    defaultMessage: 'Sign in with {idp}.',
    description: 'Default description for an IDP sign-in option.',
  },
});

export default chooseSignInMethodMessages;
